import type { LanguageCode } from '@/interfaces';
import { fetchTranslationsData } from '@/utils/translation.utils';
import { useCallback, useState } from 'react';
import useSecondEffect from './useSecondEffect.hooks';

type UseTranslation = ({
  languageCode,
  defaultTranslations,
  initialTranslations,
}: {
  languageCode: LanguageCode;
  defaultTranslations: Record<string, string>;
  initialTranslations: Record<string, string>;
}) => (key: string) => string;

const useTranslations: UseTranslation = ({ languageCode, defaultTranslations, initialTranslations }) => {
  const [translations, setTranslations] = useState<Record<string, string>>(initialTranslations);

  const t = useCallback(
    (key: string) => {
      return translations[key] || defaultTranslations[key] || key;
    },
    [defaultTranslations, translations],
  );

  useSecondEffect(() => {
    (async () => {
      try {
        const translationsData = await fetchTranslationsData(languageCode);
        setTranslations(translationsData);
      } catch (error) {
        console.error('getPmtTranslationsData error', error);
      }
    })();
  }, [languageCode, fetchTranslationsData]);

  return t;
};

export default useTranslations;
